module.exports = __webpack_public_path__ + "static/logos/icon-whatsapp-3ebfa571c4cea77bad7a17738e421373.svg";